const OdsLookupOutput = props => {
    if (props.question.value?.org_code && props.question.value?.org_name) {
        return `${props.question.value.org_name} (${props.question.value.org_code})`;
    }

    return null;
};

export default OdsLookupOutput;
